export const STRAPI_EXCLUDE_FROM_SITEMAP_TAG = 'exclude-from-sitemap';
export const STRAPI_DEINDEX_TAG = 'deindex';
export const STRAPI_UID_SEPARATOR = '--';
